import { setTenantTimeZone } from '@/time/tenantTime'
import { defineStore } from 'pinia'
import { ref } from 'vue'

/** Session shell only (assessment §159: Pinia 仅会话外壳、布局和短期 UI 状态). Server data is never cached here — TanStack Query owns it. */
export const useSessionStore = defineStore('session', () => {
  const accessToken = ref<string | null>(null)
  const tenantId = ref<string | null>(null)
  const displayName = ref('') // DstMax `name` claim; `sub` fallback (display only — never an authorization input)
  const tenantRole = ref<string | null>(null)
  const sidebarCollapsed = ref(false)
  function signIn(token: string, tenant: string, name = '', role: string | null = null): void {
    if (tenantId.value !== tenant) setTenantTimeZone('Asia/Shanghai')
    accessToken.value = token
    tenantId.value = tenant
    displayName.value = name
    tenantRole.value = role
  }
  function signOut(): void {
    setTenantTimeZone('Asia/Shanghai')
    accessToken.value = null
    tenantId.value = null
    displayName.value = ''
    tenantRole.value = null
  }
  return { accessToken, tenantId, displayName, tenantRole, sidebarCollapsed, signIn, signOut }
})
